import React, { Component, createRef } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import css from 'css';

import Summary from './Summary';
import Contact from './Contact';
import FileUpload from './FileUpload';
import Notes from './Notes';
import Cachier from './Cachier';
import Terms from './Terms';
import PaymentMethods from './PaymentMethods';
import Success from './Success';
import TimeSchedule from './TimeSchedule';
import Diploma from './Diploma';

import { Progressbar } from 'partials/shared';
import Loader from 'partials/Loader';
import Arrow from 'images/Arrow';
import CloseIcon from 'images/CloseIcon';
import MinifyIcon from 'images/MinifyIcon';

import { cookie, msg, gtmPush } from 'helpers';

import {
    setCheckoutVisibility,
    setCheckoutStep,
    setCheckoutLoading,
    resetCheckout,
    resetCheckoutCustomer,
    resetCheckoutOpportunity,
    resetCheckoutError,
} from 'store';

const Wrapper = styled.section`
    position: fixed;
    background: ${css.colors.main};
    width: 100%;
    height: 100%;
    top:0;
    left:0;
    overflow-y:auto;
    z-index: 999;
`

const StepsHeader = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 30px;

    @media(min-width: 768px) {
        padding: 30px 50px;
    }

    .float-left {
        margin-right: auto;
    }

    .float-right {
        margin-left: auto;
    }

    button {
        cursor: pointer;
        color: #FFFFFF;
        cursor: pointer;
    }
`
const CloseButton = styled.button``

const ReturnButton = styled.button``

const Steps = styled.div`
    display: flex;
    width: 100%;
    margin: 50px auto;
    flex-flow: column;
    justify-content: center;

    @media(min-width: 768px) {
        width: 1000px;
    }
`
const Title = styled.h1`
    margin-bottom: 30px;
    padding: 0 30px;
    font-size: 2em;
    line-height: 1em;
    color: #FFF;
    text-align: center;

    @media(min-width: 768px) {
        font-size: 3em;
    }
`

const Subtitle = styled.p`
    margin-bottom: 30px;
    padding: 0 30px;
    color: #FFF;
    text-align: center;
`

const ProgressbarWrapper = styled.div`
    margin-bottom: 30px;
`

const StepsWrapper = styled.div`
    padding: 30px;
`

const LoaderWrapper = styled.div`
    margin: 0 auto;
    padding: 30px;
`

const Error = styled.div`
    display: none;
    background: #F3E2E1;
    padding: 15px;
    margin-bottom: 30px;
    border-bottom: 4px solid #FF3232;
    align-items: center;
    justify-content: space-between;

    &.active {
        display: flex;
    }

    svg {
        cursor: pointer;
    }
`

const NextButton = styled.button`
    color: #FFFFFF;
    font-size: 18px;
    border: 1px solid #FFFFFF;
    padding: 15px 60px;
    margin: 0 auto;
    width: 60%;
    cursor: pointer;

    &:disabled {
        opacity: 0.5;
    }
`;

const StepsFooter = styled.div`
    display: flex;
    justify-content: center;
    padding: 30px;
    margin: 30px 0;

    button {
        color: #FFFFFF;
        text-decoration: underline;
        cursor: pointer;
    }
`

const CancelButton = styled.button``

class Checkout extends Component {
    constructor(props) {
        super(props);
        this.errorRef = createRef();
    }

    componentDidMount() {
        if (cookie.get('shoppingCartStep')) {
            let step = parseInt(cookie.get('shoppingCartStep'), 10);
            if (step > 2) {
                step = 2;
            }
            this.props.setCheckoutStep(step);
        } else {
            cookie.set('shoppingCartStep', 0, 1);
        }
        this.props.history.listen(() => {
            this.props.setCheckoutVisibility(false);
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.checkout.error != this.props.checkout.error && this.props.checkout.error) {
            this._scrollToError();
        }
    }

    _scrollToError() {
        this.errorRef.current.scrollIntoView();
    }

    _closeCheckout() {
        this.props.setCheckoutVisibility(false);
        gtmPush({
            'event': 'virtual_pageview',
            'pageTitle': document.title,
            'pageURI': this.props.history.location.pathname
        });
        gtmPush({
            'event': 'GAEvent',  
            'eventCategory': 'checkout',  
            'eventAction': 'minimize',  
            'eventLabel': 'Minimize Checkout',  
            'eventValue': 5,  
            'nonInteraction': false
        });

    }

    _cancelCheckout() {
        this.props.resetCheckout();
        this.props.resetCheckoutCustomer();
        this.props.resetCheckoutOpportunity();
        this.props.setCheckoutVisibility(false);
        this._removeCookie();
        gtmPush({
            'event': 'virtual_pageview',
            'pageTitle': document.title,
            'pageURI': this.props.history.location.pathname
        })
    }

    _removeCookie(){
        if(cookie.get('shoppingCart')){
            cookie.set('shoppingCart', JSON.stringify([]), 1);
        }
        if (cookie.get('shoppingCartTimeScheduleSpring')){
            cookie.set('shoppingCartTimeScheduleSpring', "", 1);
        }
        if (cookie.get('shoppingCartTimeScheduleAutumn')){
            cookie.set('shoppingCartTimeScheduleAutumn', "", 1);
        }
        if (cookie.get('shoppingCartUserData')){
            cookie.set('shoppingCartUserData', "", 1);
        }
        if (cookie.get('shoppingCartStep')){
            cookie.set('shoppingCartStep', 0, 1);
        }
    }

    _previousStepCheckout() {
        const { step } = this.props.checkout;

        this.props.resetCheckoutError(false);
        this.props.setCheckoutLoading(false);

        if (step == 0) {
            this.props.setCheckoutVisibility(false);
        } else {
            this.props.setCheckoutStep(step - 1);
        }
    }

    _nextStepCheckout() {
        const { step, nextCallback, error } = this.props.checkout;

        if (error) {
            this._scrollToError();
        }

        this.props.setCheckoutLoading(true);

        let result = nextCallback();

        if (false === result) {
            this.props.setCheckoutLoading(false);

            return;
        }

        result.then(response => {
            if (true === response) {
                this.props.resetCheckoutError(false);
                this.props.setCheckoutStep(step + 1);
            }

            this.props.setCheckoutLoading(false);
        });
    }

    _closeError() {
        this.props.resetCheckoutError(false);
    }

    _getCheckoutSteps() {

        const { initStep } = this.props.checkout;

        let steps = [];

        if (!initStep || initStep <= 0) {
            steps.push({
                flow: <TimeSchedule />,
                title: 'Timeplanlegger'
            });
        }

        if (!initStep || initStep <= 1) {
            steps.push({
                flow: <Summary />,
                title: 'Liste'
            });
        }

        if (!initStep || initStep <= 2) {
            steps.push({
                flow: <Contact />,
                title: 'Kontaktdetaljer'
            });
        }

        if (!initStep || initStep <= 3) {
            steps.push({
                flow: <Diploma />,
                title: 'Vedlegg'
            });
        }

        if (!initStep || initStep <= 4) {
            steps.push({
                flow: <Cachier />,
                title: 'Oppsummering'
            });
        }

        if (!initStep || initStep <= 5) {
            steps.push({
                flow: <PaymentMethods />,
                title: 'Bestilling'
            });
        }

        if (!initStep || initStep <= 6) {
            steps.push({
                flow: <Success />,
                title: 'Bekreftelse'
            });
        }

        return steps;
    }

    render() {
        const { visible, step, title, subtitle, loading, error, minimizeButton, closeButton, returnButton } = this.props.checkout;
        
        if (!visible) {
            return null;
        }

        const workflow = this._getCheckoutSteps();

        return (
            <Wrapper step={step}>
                <StepsHeader>
                    <div className="float-left">
                        {((returnButton && minimizeButton) || (returnButton && !minimizeButton && step > 1)) &&
                            <ReturnButton onClick={this._previousStepCheckout.bind(this)}>
                                <Arrow color="#FFFFFF" /> Tilbake
                            </ReturnButton>
                        }
                    </div>
                    <div className="float-right">
                        {(minimizeButton && step < workflow.length - 1) &&
                            <CloseButton onClick={this._closeCheckout.bind(this)}>
                                <span>Minimer</span> <MinifyIcon color="#FFFFFF" />
                            </CloseButton>
                        }
                        {(closeButton && step >= workflow.length - 1) &&
                            <CloseButton onClick={this._cancelCheckout.bind(this)}>
                                <CloseIcon color="#FFFFFF" />
                            </CloseButton>
                        }
                    </div>
                </StepsHeader>
                <Steps>
                    <Title> {title} </Title>
                    {subtitle &&
                        <Subtitle> {subtitle} </Subtitle>
                    }
                    <ProgressbarWrapper>
                        <Progressbar current={step} steps={workflow} />
                    </ProgressbarWrapper>
                    <StepsWrapper>
                        <Error className={error ? 'active' : ''}>
                            <div className="message-wrapper" ref={this.errorRef}>
                                <p className="message"> {error} </p>
                                {this.props.checkout.showAdvisor && (
                                    <p className="advise"> {msg('pleaseContactAdvisor')} </p>
                                )}
                            </div>
                            <CloseButton onClick={this._closeError.bind(this)}>
                                <CloseIcon color="#FF3232" />
                            </CloseButton>
                        </Error>
                        {workflow[step].flow}
                    </StepsWrapper>
                    {loading &&
                        <LoaderWrapper>
                            <Loader color="#fff" />
                        </LoaderWrapper>
                    }
                    {(step < workflow.length - 1 && !loading) &&
                        <NextButton onClick={this._nextStepCheckout.bind(this)}>
                            Neste
                        </NextButton>
                    }
                </Steps>
                <StepsFooter>
                    {step < workflow.length - 1 &&
                        <CancelButton onClick={this._cancelCheckout.bind(this)}>
                            Avbryt
                        </CancelButton>
                    }
                    {step >= workflow.length - 1 &&
                        <CancelButton onClick={this._cancelCheckout.bind(this)}>
                            Lukk
                        </CancelButton>
                    }
                </StepsFooter>
            </Wrapper>
        );
    }
}

const mapStateToProps = state => ({
    checkout: state.checkout
});

const actions = {
    setCheckoutVisibility,
    setCheckoutStep,
    setCheckoutLoading,
    resetCheckout,
    resetCheckoutCustomer,
    resetCheckoutOpportunity,
    resetCheckoutError
}

export default withRouter(connect(mapStateToProps, actions)(Checkout));


// WEBPACK FOOTER //
// ./src/partials/Checkout/Checkout.js